import { render } from "./FaqItem.vue?vue&type=template&id=bebe28cc&scoped=true&ts=true"
import script from "./FaqItem.ts?vue&type=script&lang=ts&external"
export * from "./FaqItem.ts?vue&type=script&lang=ts&external"

import "./FaqItem.scss?vue&type=style&index=0&id=bebe28cc&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bebe28cc"]])

export default __exports__